import { render, staticRenderFns } from "./AddCourseCharge.vue?vue&type=template&id=233ff992&scoped=true&"
import script from "./AddCourseCharge.vue?vue&type=script&lang=js&"
export * from "./AddCourseCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ff992",
  null
  
)

export default component.exports